import React from 'react'

export default props => (
    <td {...props}
		align={props.alignRight ? 'right' : (props.alignCenter ? 'center' : 'left')}
		onClick={props.onClick}
		title={props.small ? (props.title || props.children) : null}
		style={{
			paddingTop: 2,
			paddingLeft: props.alignRight ? 0 : 2,
			paddingRight: props.alignRight ? 0 : 2,
			paddingBottom: 2,
			verticalAlign: 'middle',
			minWidth: props.minWidth,
			color: props.color,
			fontWeight: props.bold ? 'bold' : null,
			backgroundColor: props.backgroundColor,
			maxWidth: props.noWrap ? 0 : null,
			overflow: props.noWrap ? 'hidden' : null,
			textOverflow: props.noWrap ? 'ellipsis' : null,
			whiteSpace: props.noWrap ? 'nowrap' : null,
			fontSize: props.smallMin ? 9 : (props.small ? 11 : null)
		}}>
		{props.children}
	</td>
)
